// extracted by mini-css-extract-plugin
export default {"container":"layout-module--container--46809","content":"layout-module--content--1704e","cookiesContainer":"layout-module--cookiesContainer--d948c"};